import createModelInstance from 'utils/createModelInstance';
import validateForm from 'utils/validateForm';
import Address from './Address';

const CollectionDetails = (collectionDetailsObj) => {
    let newCollectionDetailsObj = {
        collectionAddressOption: '',
        collectionAddress: Address(),
        collectionProducts: []
    };

    if(collectionDetailsObj?.collectionDetails?.collectionProducts) {
        collectionDetailsObj.collectionDetails.collectionProducts.map(product => {
            product.value = product.name

            return product
        })
    }

    if(collectionDetailsObj?.collectionDetails?.collectionAddress) {
        collectionDetailsObj.collectionDetails.collectionAddress = Address(collectionDetailsObj.collectionDetails.collectionAddress)
    }

    const collectionDetailObject = collectionDetailsObj?.collectionDetails !== undefined ? collectionDetailsObj.collectionDetails : collectionDetailsObj;

    newCollectionDetailsObj = createModelInstance(newCollectionDetailsObj, collectionDetailObject);

    return {
        ...newCollectionDetailsObj,
        /**
         * Converts the data of a model to the format to display it in the custom table
         * mainly use in the confirmation pages
         */
        toCustomTable() {
            let collectionAddressOptionName = '';

            switch (this.collectionAddressOption) {
                case 'postal_address':
                    collectionAddressOptionName = 'Other Home Address';
                    break;

                case 'vet_address':
                    collectionAddressOptionName = 'Vet Address';
                    break;

                case 'customer_address':
                    collectionAddressOptionName = "Owner's Home Address";
                    break;

                default:
                    collectionAddressOptionName = '';
                    break;
            }

            let collectionAddressData = [
                ['Collection Address', collectionAddressOptionName]
            ];

            if (this.collectionAddressOption === 'postal_address') {
                let collectionAddressText = [
                    this.collectionAddress.street,
                    this.collectionAddress.city,
                    this.collectionAddress.postalcode,
                    this.collectionAddress.state,
                    this.collectionAddress.country
                ];

                const collectionAddress = [
                    ['Other Home Address', collectionAddressText.join(', ')],
                ];

                collectionAddressData = [...collectionAddressData, ...collectionAddress];
            }

            return collectionAddressData;
        },
        /**
         * Validates the data to submit, the keys/values are the required fields
         *
         * @param {object} objOptions
         *
         * @returns {Array} an string array of the fields with errors or empty array if it's valid
         */
        validateRequiredData(objOptions) {
            let formFields = {
                collectionAddressOption: this.collectionAddressOption,
            };

            let requiredValidation = validateForm(formFields);

            // Map the error array
            requiredValidation = requiredValidation.map(validation => {
                return {
                    field: validation,
                    message: '',
                };
            });

            return requiredValidation;
        },
    };
};

export default CollectionDetails;
